import { regionsSlice } from "./regionsSlice";
import * as defaultActions from "../../../../../redux/_common";

import { get } from "../../../../../api/requester";
import { Dispatch } from "redux";
import { getErrorMessage } from "../../../../../redux/_helpers";

const { actions } = regionsSlice;
const moduleUrl = '/api/masterdata/regions'

export const setValidationErrors = actions.setValidationErrors;

export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );



export const getRegionsFromCountry = (countryId:string) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setItemsSelectLoading(true));
    const result = await get(`/api/masterdata/countries/${countryId}/regions`);
    dispatch(actions.setDropDownItems(result));

  } catch (errors) {
      const error = getErrorMessage(errors, "Error occured during fetching countries for region!");
      dispatch(actions.catchError({ errors: error, callType: "actionsLoading", errorProp: "errorAction" }));
  } finally {
    dispatch(actions.setItemsSelectLoading(false));
  }
}
  
export const getRegionsFromCountryBilling = (countryId:string) => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setItemsBillingSelectLoading(true));
    const result = await get(`/api/masterdata/countries/${countryId}/regions`);
    dispatch(actions.setItemsBillingSelect(result));

  } catch (errors) {
      const error = getErrorMessage(errors, "Error occured during fetching countries for region!");
      dispatch(actions.catchError({ errors: error, callType: "actionsLoading", errorProp: "errorAction" }));
  } finally {
    dispatch(actions.setItemsBillingSelectLoading(false));
  }
}

export const clear = () => defaultActions.clearAll(actions);
export const clearItem = () => defaultActions.clearItem(actions);
export const clearErrors = () => defaultActions.clearErrors(actions)